/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/116-user-plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6 11.5a5.508 5.508 0 013.594-5.159A4.574 4.574 0 0010 4.5C10 2.015 10 0 7 0S4 2.015 4 4.5c0 1.548.898 3.095 2 3.716v.825C2.608 9.318 0 10.985 0 13h6.208A5.5 5.5 0 016 11.5z"/><path pid="1" d="M11.5 7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm2.5 5h-2v2h-1v-2H9v-1h2V9h1v2h2v1z"/>'
  }
})
